"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supplierPurchaseActionApi = supplierPurchaseActionApi;
exports.supplierPurchaseListApi = supplierPurchaseListApi;
exports.supplierReconciliationListApi = supplierReconciliationListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function supplierPurchaseListApi(params) {
  return (0, _request.default)({
    url: '/admin/supplier/decoration/purchase/list',
    method: 'get',
    params: params
  });
}
function supplierPurchaseActionApi(id, data) {
  return (0, _request.default)({
    url: "/admin/supplier/decoration/purchase/".concat(id, "/action"),
    method: 'post',
    data: data
  });
}
function supplierReconciliationListApi(params) {
  return (0, _request.default)({
    url: '/admin/supplier/decoration/purchase/reconciliation/list',
    method: 'get',
    params: params
  });
}